export default "__VITE_ASSET__FaN_h11z__"